import { useIntl } from "react-intl"

import { Button, Dialog, ICONS, StaffBodyTextXS, StaffHeading3 } from "@doktor-se/bones-ui"

import styles from "./ConfirmReportSent.module.scss"

interface FlagProps {
  isOpen: boolean
  onClose: () => void
}

const ConfirmReportSent = ({ isOpen, onClose }: FlagProps) => {
  const intl = useIntl()

  return (
    <Dialog isOpen={isOpen} closeAriaLabel={intl.formatMessage({ id: "modal.close" })} fixedWidth>
      <div className={styles.contentWrapper}>
        <ICONS.CheckCircleOutline />
        <StaffHeading3>{intl.formatMessage({ id: "flag.popup.header" })}</StaffHeading3>
        <StaffBodyTextXS>{intl.formatMessage({ id: "flag.popup.message" })}</StaffBodyTextXS>
        <Button color="primary" variant="primary" onPress={onClose} fullWidth>
          {intl.formatMessage({ id: "label.close" })}
        </Button>
      </div>
    </Dialog>
  )
}

export default ConfirmReportSent
